import React from 'react';
import { ReactComponent as FacebookIcon } from '../images/facebook.svg'
import { ReactComponent as TwitterIcon } from '../images/twitter.svg'
import { ReactComponent as InstagramIcon } from '../images/instagram.svg'
import { ReactComponent as Quote } from '../images/quote.svg'
import { ReactComponent as QuoteCGI } from '../images/quote-cgi.svg'
import NewsroomList from './NewsroomList';

const MayorView: React.FunctionComponent<any> = ({ type, details, news }) => {
  const getColor = (person: any) => {
    if (person.isCGI) {
      if (person.pilot_program === "Yes") {
        return "bg-main-green";
      }
      return "bg-light-green";
    } else {
      if (person.pilot_program === "Yes") {
        return "bg-main-purple";
      }
      return "bg-light-purple";
    }
  }

  return (
    <div className="overflow-y-auto px-2.5 md:px-6" style={{ height: 'calc(100% - 120px)' }}>
      <div className="flex items-center pb-3">
        <div className="flex-none block w-20 h-20 border-4 p-1 border-black">
          <span className={`block w-full h-full ${getColor(details)}`}></span>
        </div>
        <div className="flex-1 pl-4">
          <p className="block text-xl font-bold">{details.city || details.county}, {details.state}</p>
          {details.pilot_program === 'Yes' &&
            <p className="block text-sm">{details.city || details.county}, {details.state} has a pilot program.</p>
          }
        </div>
      </div>
      <div className="py-6 border-t border-black">
        <span className="block text-xl font-bold mb-2">{details.mayors_name || details.county_officials_name}</span>
        <div className="flex">
          <div className="flex-none">
            <div className="w-28 h-28 border-4 border-black relative">
              <div className="border-4 border-white" style={{
                width: '104px', height: '104px', backgroundSize: 'cover', backgroundPosition: 'center', backgroundImage: `url(${details.mayor_photo_link || details.county_officials_photo_link
                  })`
              }}></div>
            </div>
            <div className="flex items-center justify-center my-2">
              {(details.facebook !== 'NA' && details.facebook !== '') &&
                <a href={`https://www.facebook.com/${details.facebook}`} target="_blank" rel="noreferrer">
                  <FacebookIcon />
                </a>
              }
              {(details.twitter !== 'NA' && details.twitter !== '' ) && 
                <a href={`https://twitter.com/${details.twitter}`} target="_blank" rel="noreferrer" className="mx-2">
                  <TwitterIcon />
                </a>
              }
              {(details.instagram !== 'NA' && details.instagram !== '' ) &&
                <a href={`https://instagram.com/${details.instagram}`} target="_blank" rel="noreferrer">
                  <InstagramIcon />
                </a>
              }
            </div>
          </div>
          <div className="flex-1 text-sm font-light pl-3 py-4 relative">
            <p className="relative z-10">{details.mayor_quote || details.county_officials_quote}</p>
            { details.isCGI &&
              <QuoteCGI className="absolute top-0 left-2 absolute" />
            }
            { !details.isCGI &&
              <Quote className="absolute top-0 left-2 absolute" />
            }
          </div>
        </div>
      </div>
      {(details.pilot_program === 'Yes' && details.pilot_description && details.pilot_link) &&
        <div className="py-6 border-t border-black">
          <p className="block text-xl font-bold">About the Pilot</p>
          {details.pilot_description &&
            <p className="my-2 text-sm font-light">{details.pilot_description}</p>
          }
          {details.pilot_link &&
            <a className="border-2 border-black inline-block mt-2 p-2 text-xs font-bold uppercase" href={details.pilot_link} target="_blank" rel="noreferrer">Read More →</a>
          }
        </div>
      }
      {news?.length > 0 &&
        <NewsroomList data={news} />
      }
    </div>
  )
}

export default MayorView;